"use strict";

exports.__esModule = true;
exports.UserWrapper = exports.OverflowEllipsis = exports.IdNumber = exports.EditedLabel = exports.DescriptionWrapper = exports.DateWrapper = exports.Body = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DescriptionWrapper = exports.DescriptionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__DescriptionWrapper",
  componentId: "sc-1tfjea4-0"
})(["display:grid;grid-template-areas:\"username timestamp editedlabel topright\" \"body body body body\";grid-template-columns:min-content min-content auto min-content;margin:3px;"]);
var OverflowEllipsis = exports.OverflowEllipsis = _styledComponents["default"].div.withConfig({
  displayName: "styles__OverflowEllipsis",
  componentId: "sc-1tfjea4-1"
})(["text-overflow:ellipsis;overflow:hidden;white-space:nowrap;"]);
var Body = exports.Body = _styledComponents["default"].div.withConfig({
  displayName: "styles__Body",
  componentId: "sc-1tfjea4-2"
})(["grid-area:body;overflow:hidden;font-size:", ";margin-bottom:0.3rem;"], (0, _Theme.val)("fontSizeSmall"));
var UserWrapper = exports.UserWrapper = (0, _styledComponents["default"])(OverflowEllipsis).withConfig({
  displayName: "styles__UserWrapper",
  componentId: "sc-1tfjea4-3"
})(["grid-area:username;font-size:0.8rem;font-weight:600;color:", ";max-width:150px;"], (0, _Theme.val)("color"));
var IdNumber = exports.IdNumber = _styledComponents["default"].div.withConfig({
  displayName: "styles__IdNumber",
  componentId: "sc-1tfjea4-4"
})(["grid-area:topright;padding-right:5px;text-align:right;font-size:", ";color:", ";"], (0, _Theme.val)("fontSizeXS"), (0, _Theme.val)("LogbookMutedTextColor"));
var DateWrapper = exports.DateWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__DateWrapper",
  componentId: "sc-1tfjea4-5"
})(["grid-area:timestamp;padding-left:10px;font-size:", ";color:", ";white-space:nowrap;"], (0, _Theme.val)("fontSizeXS"), (0, _Theme.val)("LogbookMutedTextColor"));
var EditedLabel = exports.EditedLabel = _styledComponents["default"].span.withConfig({
  displayName: "styles__EditedLabel",
  componentId: "sc-1tfjea4-6"
})(["grid-area:editedlabel;padding:1px 0 0 10px;color:", ";font-size:", ";"], (0, _Theme.val)("LogbookMutedTextColor"), (0, _Theme.val)("fontSizeXXXS"));